import { User } from 'api/types'
import { useHistory } from 'react-router-dom'
import { useAppDispatch } from 'store'
import { setCustomer } from 'reducers/customer'
import {
  CustomerDisplayNameType,
  getCustomerDisplayName,
  convertUserToCustomer,
} from 'utils/customer'
import { RequestContext } from 'utils/pos'
import { MarketAccessory, MarketList, MarketRow } from '@market/react'
import { formatPhoneNumber } from 'utils/phoneNumber'
import { ReactComponent as Human } from '@market/icons/assets/svg/human.svg'

type Props = {
  users: User[]
}

const SearchResults = ({ users }: Props) => {
  const history = useHistory()
  const dispatch = useAppDispatch()

  if (!users) {
    return null
  }

  const onClickCustomer = (user: User) => {
    dispatch(
      setCustomer({
        customer: convertUserToCustomer(user),
        context: RequestContext.SEARCH_CUSTOMERS,
      })
    )
    history.push(`/customer` + history.location.search)
  }

  const getInitial = (customer: User) => {
    if (customer.first_name && customer.last_name) {
      return (
        (customer.first_name.substring(0, 1) ?? '') +
        (customer.last_name.substring(0, 1) ?? '')
      ).toUpperCase()
    }
  }

  return (
    <MarketList className="market-grid-item-full" interactive slot={'content'}>
      {users.map(customer => {
        return (
          <MarketRow
            key={customer.identifier}
            className="noHover"
            data-testid="search-customer-result"
            onClick={() => {
              onClickCustomer(customer)
            }}
            variant="drill"
          >
            <MarketAccessory
              slot="leading-accessory"
              size="image"
              className="addons-market-accessory-customer-display-image"
            >
              <div className="addons-market-accessory-customer-display-image-content">
                {getInitial(customer) ?? (
                  <Human
                    className="addons-search-customer-display-image"
                    width="24"
                    height="24"
                  />
                )}
              </div>
            </MarketAccessory>
            <label slot="label" style={{ margin: '5px 0' }}>
              {getCustomerDisplayName(convertUserToCustomer(customer), [
                CustomerDisplayNameType.NAME,
              ])}
            </label>
            <p slot="subtext">{customer.email}</p>
            {!!customer.phone && (
              <p slot="subtext">{formatPhoneNumber(customer.phone)}</p>
            )}
          </MarketRow>
        )
      })}
    </MarketList>
  )
}

export default SearchResults
